import React, { lazy } from 'react';
export function ProductDescription() {
  return <section className="max-w-7xl mx-auto px-4 py-8 sm:py-12 md:py-16" data-id="element-339">
      <div className="grid md:grid-cols-2 gap-6 sm:gap-8 md:gap-12 items-center mb-8 sm:mb-12" data-id="element-340">
        <div data-id="element-341">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6" data-id="element-342">
            ¿Por Qué Este Libro Es Diferente?
          </h2>
          <div className="space-y-3 sm:space-y-4 md:space-y-6 text-gray-700 leading-relaxed" data-id="element-343">
            <p className="text-sm sm:text-base md:text-lg" data-id="element-344">
              No es otro libro de recetas que promete "rapidez" y luego te pide
              10 ingredientes que no tienes.
            </p>
            <p className="font-semibold text-base sm:text-lg md:text-xl text-orange-600" data-id="element-345">
              Cada receta en este libro ha sido:
              <br data-id="element-346" />
              ✓ Cronometrada con reloj en mano
              <br data-id="element-347" />
              ✓ Probada por familias reales
              <br data-id="element-348" />✓ Diseñada con ingredientes que YA tienes
            </p>
            <p className="text-sm sm:text-base" data-id="element-349">
              <strong data-id="element-350">15 minutos significa 15 minutos.</strong> No "15 minutos
              más el tiempo de preparación". No "15 minutos si ya tienes todo
              listo". Son 15 minutos reales, desde que prendes la estufa hasta
              que sirves el plato.
            </p>
          </div>
          <div className="mt-4 sm:mt-6 rounded-lg sm:rounded-xl overflow-hidden shadow-xl" data-id="element-351">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hsgq5SCcsYLyhUtouxXDrq/GcNnp3C-RJE46_7aoC5lK.png" alt="Comida deliciosa preparada en minutos" loading="lazy" className="w-full h-48 sm:h-56 md:h-64 object-cover" data-id="element-352" />
          </div>
        </div>
        <div className="rounded-lg sm:rounded-xl overflow-hidden shadow-2xl" data-id="element-353">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/xrxLK2HTtkCuD1rRnxvZGS/modelo_4.png" alt="Mujer leyendo 50 Recetas de 15 Minutos" loading="lazy" className="w-full h-full object-cover" data-id="element-354" />
        </div>
      </div>
      <div className="bg-orange-50 p-4 sm:p-6 md:p-8 rounded-lg sm:rounded-xl my-6 sm:my-8" data-id="element-355">
        <h3 className="font-bold text-lg sm:text-xl md:text-2xl mb-4 sm:mb-6" data-id="element-356">
          Lo Que Vas a Encontrar:
        </h3>
        <div className="grid sm:grid-cols-2 gap-3 sm:gap-4 md:gap-6" data-id="element-357">
          <div data-id="element-358">
            <div className="font-semibold mb-2 text-sm sm:text-base md:text-lg" data-id="element-359">
              🍝 Pastas Express
            </div>
            <p className="text-xs sm:text-sm md:text-base text-gray-700" data-id="element-360">
              10 recetas de pasta que van más allá del típico "con mantequilla"
            </p>
          </div>
          <div data-id="element-361">
            <div className="font-semibold mb-2 text-sm sm:text-base md:text-lg" data-id="element-362">
              🍗 Pollo en Minutos
            </div>
            <p className="text-xs sm:text-sm md:text-base text-gray-700" data-id="element-363">
              12 formas de cocinar pollo que tu familia va a pedir
            </p>
          </div>
          <div data-id="element-364">
            <div className="font-semibold mb-2 text-sm sm:text-base md:text-lg" data-id="element-365">
              🥗 Ensaladas Completas
            </div>
            <p className="text-xs sm:text-sm md:text-base text-gray-700" data-id="element-366">
              8 ensaladas que son comidas completas, no guarniciones
            </p>
          </div>
          <div data-id="element-367">
            <div className="font-semibold mb-2 text-sm sm:text-base md:text-lg" data-id="element-368">
              🍚 Arroces y Granos
            </div>
            <p className="text-xs sm:text-sm md:text-base text-gray-700" data-id="element-369">
              10 recetas con arroz, quinoa y más que se cocinan rápido
            </p>
          </div>
          <div data-id="element-370">
            <div className="font-semibold mb-2 text-sm sm:text-base md:text-lg" data-id="element-371">
              🌮 Tacos y Wraps
            </div>
            <p className="text-xs sm:text-sm md:text-base text-gray-700" data-id="element-372">
              5 ideas de tacos express que no son aburridos
            </p>
          </div>
          <div data-id="element-373">
            <div className="font-semibold mb-2 text-sm sm:text-base md:text-lg" data-id="element-374">
              🥘 One-Pot Meals
            </div>
            <p className="text-xs sm:text-sm md:text-base text-gray-700" data-id="element-375">
              5 comidas completas en una sola olla
            </p>
          </div>
        </div>
      </div>
      <p className="text-base sm:text-lg md:text-xl text-center italic text-orange-600 py-4 sm:py-6 md:py-8 px-4" data-id="element-376">
        Menos estrés en la cocina. Más tiempo con tu familia. Y comida que todos
        van a disfrutar.
      </p>
    </section>;
}